import React, { useEffect, useState } from "react";

import { useUser } from "../../DataService/UserContext";
import DashboardLayout from "./Components/DashboardLayout";
import { DashboardCourses } from "./Components/DashboardCourses";
import { DashboardHistory } from "./Components/DashboardHistory";
import { DashboardOverview } from "./Components/DashboardOverview";
import { DashboardProfile } from "./Components/DashboardProfile";
import { DashboardResources } from "./Components/DashboardResources";
import { DashboardSeminars } from "./Components/DashboardSeminars";
import { apiGet } from "../../DataService/apiClient";
import { UserCourseListItem } from "../../Types/UserCourseTypes";
import { accessSync } from "fs";

export type DashboardTab =
  | "overview"
  | "history"
  | "library"
  | "seminars"
  | "resources"
  | "profile";

export const MemberDashboard = () => {
  const { user } = useUser();

  const [activeTab, setActiveTab] =
    useState<DashboardTab>("overview");
  const [hasCourseLibrary, setHasCourseLibrary] = useState(false);

  useEffect(() => {
    
    const load = async () => {
      try {
        const courses = await apiGet<UserCourseListItem[]>('/UserCourse/my-courses');
        setHasCourseLibrary((courses ?? []).length > 0);
      } catch {
        setHasCourseLibrary(false);
      }
    };

    if (user) {
      load();
    }
  }, [user]);

  if (!user) return null;
  const isMember = Boolean(
    user.membershipExpiresAt && new Date(user.membershipExpiresAt) > new Date()
  );
  const isCourseOwner = user.roles.includes("courseowner");

  return (
    <DashboardLayout
      activeTab={activeTab}
      setActiveTab={setActiveTab}
      showLibrary={isCourseOwner || hasCourseLibrary}
    >
      {activeTab === "overview" && <DashboardOverview />}
      {activeTab === "history" && <DashboardHistory />}
      {activeTab === "library" && (isCourseOwner || hasCourseLibrary) && <DashboardCourses />}
      {activeTab === "seminars" && <DashboardSeminars />}
      {activeTab === "resources" && isMember && <DashboardResources />}
      {activeTab === "profile" && <DashboardProfile />}
    </DashboardLayout>
  );
};
